import React, { useEffect, useState } from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import Item from "./Item";
import { getEmployee } from "../../../api/server";
import { useProfessionalRoles } from "../../../hooks";
import { getFullName } from "../../../components/util/helpers";
const { Title } = Typography;

const EmployeeDetails = (props) => {
  const intl = useIntl();
  const professionalRoles = useProfessionalRoles();
  const activePatient = useSelector(
    (state) => state.patientDetails.activePatient
  );
  const [employeeName, setEmployeeName] = useState(null);
  const [employeeRole, setEmployeeRole] = useState(null);

  let location = useLocation();

  useEffect(() => {
    async function fetchEmployee() {
      const isAdmin = location.pathname.includes("admin");
      const params = {
        admin: isAdmin,
        branchId: activePatient.branch,
        id: activePatient.staff_worker_in_charge_id,
      };
      let response = await getEmployee(params);
      const name = getFullName(
        response.data.surename,
        response.data.first_name
      );
      const role = professionalRoles.filter(
        (item) => item.id === response.data.professional_role_id
      )[0];
      const roleName = role.name;
      setEmployeeName(name);
      setEmployeeRole(roleName);
    }
    if (
      activePatient.staff_worker_in_charge_id &&
      professionalRoles.length > 0
    ) {
      fetchEmployee();
    }
  }, [location.pathname, activePatient, professionalRoles]);

  return (
    <div className="section" style={{ width: "100%" }}>
      <Title level={5}>
        {intl.formatMessage({
          id: "app.orders.professional_employee_details",
        })}
      </Title>
      <div className="rowContainer">
        <Item name="full_name" content={employeeName} line_type="vertical" />
        <div className="horizontal_spacer" />
        <Item
          name="professional_employee_role"
          content={
            employeeRole
              ? intl.formatMessage({
                  id: `app.dataSelect.professional_role_id.${employeeRole}`,
                })
              : ""
          }
          line_type="vertical"
        />
        <div className="horizontal_spacer" />
        <Item
          name="professional_employee_signature"
          content={employeeName}
          line_type="vertical"
        />
      </div>
    </div>
  );
};

export default EmployeeDetails;
